export default __webpack_public_path__ + "static/media/homepic.1317326d.jpg";